module.exports = __webpack_public_path__ + "static/media/poolHeater3.1f686457.jpg";